


export function createPageUrl(pageName: string) {
    return '/' + pageName.toLowerCase().replace(/ /g, '-');
}

export function formatPhoneNumber(phone: string): string {
    if (!phone) return '';
    const cleaned = phone.replace(/[\s\-\.]/g, '');
    // French +33 format: +33612345678 → +33 6 12 34 56 78
    if (/^\+33\d{9}$/.test(cleaned)) {
        return cleaned.replace(/^\+33(\d)(\d{2})(\d{2})(\d{2})(\d{2})$/, '+33 $1 $2 $3 $4 $5');
    }
    // French 0X format: 0612345678 → 06 12 34 56 78
    if (/^0\d{9}$/.test(cleaned)) {
        return cleaned.replace(/^(0\d)(\d{2})(\d{2})(\d{2})(\d{2})$/, '$1 $2 $3 $4 $5');
    }
    // Already contains spaces or other formatting → return as-is
    if (phone.includes(' ') || phone.includes('-') || phone.includes('.')) return phone;
    // Other international: group in blocks of 2-3 from the end
    if (/^\+\d{10,15}$/.test(cleaned)) {
        const cc = cleaned.match(/^(\+\d{1,3})(\d+)$/);
        if (cc && cc[1] && cc[2]) {
            const prefix = cc[1];
            const rest = cc[2];
            const groups = rest.match(/.{1,2}/g) || [];
            return prefix + ' ' + groups.join(' ');
        }
    }
    return phone;
}